"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentIntentParamsSchema = exports.createCartRequestSchema = void 0;
const zod_1 = require("zod");
const cartItemSchema = zod_1.z
    .object({
    id: zod_1.z.string().min(1).optional(),
    productId: zod_1.z.string().min(1).optional(),
    priceId: zod_1.z.string().min(1),
    locationId: zod_1.z.string().min(1).nullable().optional(),
    quantity: zod_1.z.coerce.number().int().positive(),
    amount: zod_1.z.coerce.number().int().nonnegative().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).optional(),
    discountType: zod_1.z.enum(["percentage", "fixed"]).optional(),
    discountTypeValue: zod_1.z.coerce.number().nonnegative().optional(),
    discountUnitAmount: zod_1.z.coerce.number().int().nonnegative().optional(),
})
    .passthrough();
exports.createCartRequestSchema = zod_1.z.union([
    zod_1.z.array(cartItemSchema),
    zod_1.z
        .object({
        locationId: zod_1.z.string().min(1).nullable().optional(),
        items: zod_1.z.array(cartItemSchema).min(1),
    })
        .passthrough(),
]);
exports.paymentIntentParamsSchema = zod_1.z
    .object({
    paymentIntentId: zod_1.z.string().min(1),
})
    .strict();
exports.default = {
    createCartRequestSchema: exports.createCartRequestSchema,
    paymentIntentParamsSchema: exports.paymentIntentParamsSchema,
};
//# sourceMappingURL=cart.schemas.js.map